import React, { useEffect, useState, useContext } from 'react';
import { getUserDetails, updateUserDetails } from '../../services/authService';
import { AuthContext } from '../../contexts/AuthContext';

function EditProfile() {
    const [errors, setErrors] = useState({});
    const { authTokens } = useContext(AuthContext);
    const [user, setUser] = useState({
        first_name: '',
        last_name: '',
        phone_number: '',
        country: '',
        state: '',
        city: '',
        area: '',
        date_of_birth: '',
        bio: '',
    });

    const [message, setMessage] = useState({ type: '', text: '' });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getUserDetails()
            .then((response) => {
                setUser(response.data);
                setLoading(false);
            })
            .catch((error) => {
                console.error('Error fetching user details:', error);
                setLoading(false);
            });
    }, []);

    const handleChange = (e) => {
        setUser({
            ...user,
            [e.target.name]: e.target.value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData();
        const newErrors = {};

        if (!user.first_name.trim()) {
            newErrors.first_name = 'First name is required.';
        }

        for (const key in user) {
            formData.append(key, user[key]);
        }

        updateUserDetails(formData)
            .then(() => {
                setMessage({ type: 'success', text: 'Profile updated successfully.' });
            })
            .catch((error) => {
                console.error('Error updating profile:', error);
                setMessage({
                    type: 'error',
                    text: 'Failed to update profile.',
                });
            });
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center p-4">
                <p>Loading profile...</p>
            </div>
        );
    }

    return (
        <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-gray-900 to-gray-800 text-white pt-4 pb-4">
            <div className="p-6 bg-gray-900 border border-gray-700 rounded-lg shadow-lg max-w-4xl w-full">
                <h2 className="mb-6 text-3xl font-extrabold text-center text-yellow-500">Your Profile</h2>
                {message.text && (
                    <div
                        className={`mb-4 px-4 py-2 text-white rounded ${message.type === 'success' ? 'bg-green-600' : 'bg-red-600'
                            }`}
                    >
                        {message.text}
                    </div>
                )}
                <form onSubmit={handleSubmit} encType="multipart/form-data">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {/* First Name */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">First Name</label>
                            <input
                                type="text"
                                name="first_name"
                                value={user.first_name}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="First Name"
                            />
                            {errors.first_name && <p className="text-red-400 text-sm mt-1">{errors.first_name}</p>}
                        </div>
                        {/* Last Name */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">Last Name</label>
                            <input
                                type="text"
                                name="last_name"
                                value={user.last_name}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="Last Name"
                            />
                        </div>
                        {/* Phone Number */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">Phone Number</label>
                            <input
                                type="text"
                                name="phone_number"
                                value={user.phone_number}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="Phone Number"
                            />
                        </div>
                        {/* Date of Birth */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">Date of Birth</label>
                            <input
                                type="date"
                                name="date_of_birth"
                                value={user.date_of_birth}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            />
                        </div>
                        {/* Country */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">Country</label>
                            <input
                                type="text"
                                name="country"
                                value={user.country}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="Country"
                            />
                        </div>
                        {/* State */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">State</label>
                            <input
                                type="text"
                                name="state"
                                value={user.state}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="State"
                            />
                        </div>
                        {/* City */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">City</label>
                            <input
                                type="text"
                                name="city"
                                value={user.city}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="City"
                            />
                        </div>
                        {/* Area */}
                        <div>
                            <label className="block mb-1 font-semibold text-gray-300">Area</label>
                            <input
                                type="text"
                                name="area"
                                value={user.area}
                                onChange={handleChange}
                                className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                                placeholder="Area"
                            />
                        </div>
                    </div>
                    {/* Bio Section */}
                    <div className="mt-6">
                        <label className="block mb-2 font-semibold text-gray-300">Bio</label>
                        <textarea
                            name="bio"
                            value={user.bio}
                            onChange={handleChange}
                            className="w-full px-3 py-2 bg-gray-800 border border-gray-700 rounded focus:outline-none focus:ring-2 focus:ring-yellow-500"
                            placeholder="Tell us about yourself"
                            rows="4"
                        ></textarea>
                    </div>
                    {/* Submit Button */}
                    <div className="mt-6 flex justify-end">
                        <button
                            type="submit"
                            className="px-6 py-2 font-bold text-white bg-yellow-500 rounded hover:bg-yellow-600 transition duration-150"
                        >
                            Update Profile
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default EditProfile;
